
import React from 'react';

const IRCGALAXY = () => {


    return (
        <>
            <div className="about-us-container">
                {/* Detailed Activities Section */}
                <section className="activities-details">
           <button 
          onClick={() => window.history.back()}
          style={{
            marginBottom: '10px',
            padding: '8px 10px',
            backgroundColor: '#255fe8',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          ← Back to All Activities
        </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities</p>
                    </div>

                    {/* IRC Pathology Laboratory */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>IRC PATHOLOGY LABORATORY</h3>
                        </div>
                        <div className="activity-content">
                            <p>IRC runs a pathology laboratory (located in the IRC Charitable Clinic Building) where skilled and experienced technicians and pathologists perform laboratory testing for the poor and needy at a 60% discounted rate. Alhamdulillaah, during the times when unaffordability of the expensive medical laboratory tests is a challenge for the weaker sections of our society, the IRC pathology lab has been a blessing for these underprivileged.</p>

                            <div className="clinic-card">
                                <p><strong>Name:</strong> IRC Pathology Laboratory</p>
                                <p><strong>Address:</strong> Ground Floor, IRC Community Centre, Gali No. 34, Apex Hospital Rd, behind Sikandar Funtion Hall, Baijipura, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                                <p><strong>Date of Inauguration:</strong> 17-Jul-2019</p>
                                <p><strong>No. of Patients Tested:</strong> 24,152 (till 31-Jan-2025)</p>
                                <p><strong>Contact No:</strong> 9607-9607-68</p>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </>
    );
};

export default IRCGALAXY;
